// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ChromeOutlinedSvg from "@ant-design/icons-svg/es/asn/ChromeOutlined";
import AntdIcon from '../components/AntdIcon';

var ChromeOutlined = function ChromeOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ChromeOutlinedSvg
  }));
};

ChromeOutlined.displayName = 'ChromeOutlined';
export default React.forwardRef(ChromeOutlined);